import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import AssistantChat from "@/components/AssistantChat";

export default function AssistantDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid="assistant-fab"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-24 right-6 z-40 w-14 h-14 rounded-full bg-[#1B4D3E] text-white shadow-lg hover:bg-[#143A2F] flex items-center justify-center transition-colors"
        title="Ask the Dap Advisor"
      >
        {open ? <X size={22} /> : <Sparkles size={22} />}
      </button>

      {open && (
        <div
          data-testid="assistant-drawer"
          className="fixed bottom-44 right-6 z-40 w-[92vw] sm:w-96 bg-white border border-[#DEDBD3] rounded-2xl shadow-xl overflow-hidden animate-fade-up"
        >
          <div className="bg-[#1B4D3E] text-white px-5 py-4">
            <div className="flex items-center gap-2">
              <Sparkles size={16} className="text-[#E9C7B8]" />
              <p className="font-serif-dl text-xl tracking-tight">Dap Advisor</p>
            </div>
            <p className="text-white/70 text-xs mt-0.5">Honor-based guidance, powered by Claude</p>
          </div>
          <div className="p-4">
            <AssistantChat
              mode="general"
              sessionId="general"
              welcome="I'm your Dap Advisor. Ask me anything about making and keeping honorable handshake agreements."
              placeholder="Ask about daps, honor, fairness…"
              heightClass="h-72"
            />
          </div>
        </div>
      )}
    </>
  );
}
